// Mirrors the threshold logic in aio-app-builder/ondemand-tracker/actions/longLeaveUtils.js
// (kept in sync manually — this file only decides what to *display*, the backend
// action files are the source of truth for what gets written to longLeaveRecords).

export const LONG_LEAVE_THRESHOLD_DAYS = 25;

/**
 * Inclusive calendar-day count between two YYYY-MM-DD dates (UTC).
 */
export function calendarDaysInclusive(startDate: string, endDate: string): number {
  const start = new Date(startDate + 'T00:00:00Z');
  const end = new Date(endDate + 'T00:00:00Z');
  return Math.round((end.getTime() - start.getTime()) / 86400000) + 1;
}

/**
 * True when an OOO date range exceeds the long-leave threshold (> 25 inclusive
 * calendar days).
 */
export function isLongLeaveRange(startDate?: string, endDate?: string): boolean {
  if (!startDate || !endDate || endDate < startDate) return false;
  return calendarDaysInclusive(startDate, endDate) > LONG_LEAVE_THRESHOLD_DAYS;
}
